import AbstractAlert from "./AbstractAlert.js";

/**
 * An alert representing a problem the user can't ignore.
 */
export default class ErrorAlert extends AbstractAlert {
	isError() {
		return true;
	}
}
